import React from "react";
import PropTypes from "prop-types";

const Compliance = ({ isCompliant, setIsCompliant, disabled }) => {
  return (
    <section className="compliance-section">
      <div className="compliance-section__label">Livraison conforme</div>
      <div className="compliance-section__toggle">
        <button
          type="button"
          className={`compliance-section__btn compliance-section__btn--yes${
            isCompliant === true ? " compliance-section__btn--active" : ""
          }`}
          disabled={disabled}
          onClick={() => setIsCompliant(true)}
        >
          <i className="fa fa-check" /> Conforme
        </button>
        <button
          type="button"
          className={`compliance-section__btn compliance-section__btn--no${
            isCompliant === false ? " compliance-section__btn--active" : ""
          }`}
          disabled={disabled}
          onClick={() => setIsCompliant(false)}
        >
          <i className="fa fa-times" /> Non conforme
        </button>
      </div>
    </section>
  );
};

Compliance.propTypes = {
  isCompliant: PropTypes.bool,
  setIsCompliant: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default Compliance;
